export default __webpack_public_path__ + "static/media/22.8g28mm.c99d957f.jpeg";